import localStorage from 'local-storage-fallback'
import { key } from '../../../output/Restaumatic.Form.Mapping'

const genericGetItem = (storage) => (key) => storage.getItem(key)

const genericSetItem = (storage) => (key, val) => storage.setItem(key, val)

const genericDeleteItem = (storage) => (key) => {
  const i = genericGetItem(storage)(key)
  storage.removeItem(key)
  return i
}

const genericGetJSONItem = (storage) => (key) => {
  const obj = genericGetItem(storage)(key)
  if (obj) {
    return JSON.parse(obj)
  } else {
    return obj
  }
}

const genericSetJSONItem = (storage) => (key, object) =>
  genericSetItem(storage)(key, JSON.stringify(object))

const getItem = genericGetItem(localStorage)

const setItem = genericSetItem(localStorage)

const getJSONItem = genericGetJSONItem(localStorage)

const setJSONItem = genericSetJSONItem(localStorage)

const deleteItem = genericDeleteItem(localStorage)

const sessionGetJSONItem = genericGetJSONItem(sessionStorage)

const sessionSetJSONItem = genericSetJSONItem(sessionStorage)


const removeItem = (key) => storage.removeItem(key)

const migrateAddresses = () => {
  // const needsMigration = !getItem('deliveryAddress') && (!!localStorage['address.city'])
  // TODO: add this, after Delivery is modified to use the new Address component
}

const migrateUsers = () => {
  const needsMigration = !getJSONItem('user') && (!!getItem( 'user.phone' ))
  if (needsMigration) {
    console.log("Migration - migrateUsers")
    const user = {
      email: deleteItem('user.email'),
      fullName: deleteItem('user.full_name'),
      parsedPhone: deleteItem('user.phone'),
      subscribed: deleteItem('user.subscribed')
    }
    setJSONItem("user", user)
  }
}
const migrateAgreements = () => {
  const user = getJSONItem("user")
  const agreement = getJSONItem("agreement")
  const needsMigration = !agreement && (user && !!user.parsedPhone)
  if (needsMigration) {
    console.log("Migration - migrateAgreements")
    const agreement = {
      subscribed: user.subscribed,
      tosAgreement: true
    }
    setJSONItem("agreement", agreement)
  }
}


const migrate = () => {
}

export default {
  setItem,
  getItem,
  setJSONItem,
  getJSONItem,
  // deleteItem returns the deleted item
  deleteItem,
  // removeItem will delete the item, but not return it
  removeItem,
  migrate,
  sessionSetJSONItem,
  sessionGetJSONItem
}
